import './IRAAutoMaxMboxCallToAction.scss';

const IRAAutoMaxMboxCallToAction = ({ messageName = '', messageText = '' }) => {
  if (messageName && messageText) {
    return (
      <div className="dashboard-call-to-action-container">
        <span
          className="dashboard-call-to-action-title"
          dangerouslySetInnerHTML={{
            __html: messageName,
          }}
        />

        <span
          className="dashboard-call-to-action-body"
          dangerouslySetInnerHTML={{
            __html: messageText,
          }}
        />
      </div>
    );
  }

  return null;
};

export default IRAAutoMaxMboxCallToAction;
